import React from "react";
import { Box, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { keyframes } from "@mui/system";

// Animation for the arrow bounce
const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

const TakeawayDisplay: React.FC = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
        padding: 2,
        textAlign: "center",
      }}
    >
      {/* Main Title */}
      <Typography
        variant="h1"
        sx={{
          fontSize: {
            xs: "2.5rem", // Mobile
            sm: "3.5rem", // Small tablets
            md: "4.5rem", // Medium tablets
            lg: "6rem", // Large screens
            xl: "8rem", // Extra large screens
          },
          fontWeight: "bold",
          color: "#2c3e50",
          marginBottom: 4,
          textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
          lineHeight: 1.2,
          maxWidth: "90%",
          wordBreak: "break-word",
        }}
      >
        Realizar Retirada Aqui
      </Typography>

      {/* Optional subtitle for clarity */}
      <Typography
        variant="h4"
        sx={{
          fontSize: {
            xs: "1rem", // Mobile
            sm: "1.25rem", // Small tablets
            md: "1.5rem", // Medium tablets
            lg: "2rem", // Large screens
            xl: "2.5rem", // Extra large screens
          },
          color: "#7f8c8d",
          marginTop: 3,
          fontWeight: 300,
          maxWidth: "80%",
        }}
      >
        sistema de autoatendimento
      </Typography>

      {/* Animated Arrow */}
      <KeyboardArrowDownIcon
        sx={{
          fontSize: {
            xs: "4rem", // Mobile
            sm: "5rem", // Small tablets
            md: "6rem", // Medium tablets
            lg: "8rem", // Large screens
            xl: "10rem", // Extra large screens
          },
          color: "#e74c3c",
          animation: `${bounce} 2s infinite`,
          filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.2))",
        }}
      />
    </Box>
  );
};

export default TakeawayDisplay;
